import {stage} from "../../../config/stage.ts";

export const moduleConfig = {
    entityKey: 'applicationProducts',
    pricingPageTitle: 'Flexi Domains Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary'
}

// flexinet-platform-api
const platformAPI = {
    prod: {
        endpoint: 'https://jerup2o5nzej3hnn2sdv3ejtca.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
        applicationId: '6c6f8e3b-f83d-4520-9b5b-5532d42e25af',
    },
    test: {
        endpoint: 'https://thz4u5ksajh6blvulnhiiddudi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
        applicationId: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
    },
    dev: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
        applicationId: 'b7c64440-55d7-47d6-81b4-77468bf9b7ca',
    },
    ide: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
        applicationId: 'b7c64440-55d7-47d6-81b4-77468bf9b7ca',
    },
};

export const platformApiConfig = platformAPI[stage];
